import { Injectable } from '@angular/core';
import { ConfigService } from './infrastructure/config.service';
import { catchError, map, Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ApiResponse } from 'shared/models/api-response';

@Injectable({ providedIn: 'root' })
export class PartnerResourceService {
  private readonly partnerApiBaseUrl =
    this.configService.config.msepPartnerApiBaseUrl;

  constructor(
    private readonly configService: ConfigService,
    private readonly http: HttpClient
  ) {}

  getPartnerResourceTitles(): Observable<PartnerResourceTitles[]> {
    return this.http
      .get<ApiResponse<PartnerResourceTitles[]>>(
        `${this.partnerApiBaseUrl}/partner-resource/titles`
      )
      .pipe(
        map(result => result.data),
        catchError(this.handleError)
      );
  }

  logPartnerResourceTracking(
    partnerResourceTrackingTypeId: number,
    partnerResourceId?: number,
    msep360NewsletterId?: number,
    partnerTrainingVideoId?: number
  ): Observable<void> {
    const url = `${this.partnerApiBaseUrl}/partner-resource/tracking`;
    return this.http
      .post<void>(url, {
        partnerResourceTrackingTypeId,
        partnerResourceId,
        msep360NewsletterId,
        partnerTrainingVideoId,
      })
      .pipe()
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    return throwError(() => error || 'Server error');
  }
}

export interface PartnerResourceTitles {
  id: number;
  title: string;
  partnerResourceTypeId: number;
}
